import script from "./vue3-otp-input.vue?vue&type=script&setup=true&lang=js"
export * from "./vue3-otp-input.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__